// window.addEventListener('DOMContentLoaded',function () {
// commented out because this is happened by script loader
// });
	// declare variables
	
	const sm = 640;
	const md = 768;
	const lg = 1024;
	const xl = 1280;
	const header = document.querySelector('[data-header]');

	console.log('%c T H E O R E M', 'font-weight: bold; font-size: 40px; color: #555');
	
	const debounce = (callback, wait) => {
		let timeoutId = null;
		return (...args) => {
		  window.clearTimeout(timeoutId);
		  timeoutId = window.setTimeout(() => {
			callback.apply(null, args);
		  }, wait);
		};
	  }
	
	const throttle = (fn, delay) => {
		let lastInvoke = null;
	  
		return (...args) => {
		  if (lastInvoke + delay < Date.now()) {
			lastInvoke = Date.now();
			fn(...args);
		  }
		}
	}

	
	// init 
	window.addEventListener("load", function(){
		equalheight();
	});
	
	window.addEventListener("resize", function(){
		setTimeout(function(){
			equalheight();
		})
	});

	// Match Height End
	
	const body = document.querySelector('body');
	const burger_menu = document.querySelector('[data-menu-icon]');
	const menu = document.querySelector('[data-nav]');

	burger_menu.addEventListener('click', toggleMenu);

	function toggleMenu(e) {
		e.preventDefault();
		toggleAnimation(menu)
		toggleAnimation(body)
		toggleAnimation(burger_menu.children[0])
		toggleAnimation(burger_menu.children[1])
		toggleAnimation(burger_menu.children[2])

		if (menu.classList.contains('active')) {
			header.classList.add("white-header");
		} else {
			updateHeaderColor();
		}
	}

	//data-nav-blocks-trigger
	const navBlocks = document.querySelectorAll('[data-nav-blocks]');
	Array.from(document.querySelectorAll('[data-nav-blocks-trigger]')).forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			e.preventDefault();
			const target = trigger.closest("li").querySelector("[data-nav-blocks]");
			console.log(trigger, "target", target)
			toggleAnimation(target);
			navBlocks.forEach((block) => {
				if (block !== target) {
					return block.classList.remove('expanded');
				}
				//const isNavActive = target.classList.contains('expanded');
				trigger.classList.toggle('expanded');
	
			})

			if (target.classList.contains('expanded')) {
				header.classList.add("white-header");
				header.classList.add("active")

				// defining css variable for subnav to be centred relative to trigger
				const targetWidth = target.offsetWidth; // e.g., 224px
				const triggerWidth = trigger.offsetWidth; // e.g., 95px
				const offsetValue = (-targetWidth / 2) + (triggerWidth / 2);
				target.style.setProperty('--subnav-offset-x', `${offsetValue}px`);
			} else {
				header.classList.remove("active")
				updateHeaderColor();
			}
		});
	})

	function dropdownFn(dropdown) {
		if (dropdown.dataset.closeSiblings && window.innerWidth >= xl) {
			const siblings = getAllSiblings(dropdown.parentElement, dropdown.parentElement.parentElement);
			Array.from(siblings).forEach(child => {
				if(child.children[1]) {
					let activeClass = child.children[1].dataset.addClass.split(' ');
					if (child.children[1].classList.contains(activeClass[0])) {	
						toggleAnimation(child.children[0]);
						toggleAnimation(child);
						if (child.children[0]) {
							toggleAnimation(child.children[0].children[0])
						}
						if (child.children[1]) {
							toggleAnimation(child.children[0].children[0])
						}
						toggleAnimation(child.children[1])
					}
				}
			});
		}
		
		toggleAnimation(dropdown)
		toggleAnimation(dropdown.parentElement)
		if (dropdown.children[0]) {
			toggleAnimation(dropdown.children[0])
		}
		if (dropdown.children[1]) {
			toggleAnimation(dropdown.children[1])
		}
		toggleAnimation(dropdown.nextElementSibling)
	}

	function headerDropdownInit() {
		var data_header_dropdown = document.querySelectorAll('[data-header-dropdown]');
		Array.from(data_header_dropdown).forEach((dropdown)=> {
			if (dropdown.classList.contains('init')) return;
			dropdown.classList.add('init')

			if(window.innerWidth >= xl) {
				dropdown.onmouseenter = () => eventHandler(event)
				dropdown.parentElement.onmouseleave = () => eventHandler(event)

				function eventHandler (event) {
					dropdownFn(dropdown)
				}
				dropdown.addEventListener('click', (e) => {
					e.preventDefault();
				});
			} else {

				dropdown.addEventListener('click', (e) => {
					e.preventDefault();
					dropdownFn(dropdown)
					
				})

			}

			// Checks if dropdown has data attr of data-close-siblings if it does and the window size is smaller than xl (1280) then it runs this with it always opens the dropdown
		})
	};

	headerDropdownInit();

	function dropdownInit() {
		var data_dropdown = document.querySelectorAll('[data-dropdown]');
		Array.from(data_dropdown).forEach((dropdown)=> {
			if (dropdown.classList.contains('init')) return;
			dropdown.classList.add('init')
			dropdown.addEventListener('click', (e) => {
				e.preventDefault();
				// Checks if dropdown has data attr of data-close-siblings if it does and the window size is smaller than xl (1280) then it runs this with it always opens the dropdown

				dropdownFn(dropdown)
			})

			if (dropdown.dataset.dropdownGsapUpdate !== undefined) {
				const contentElement = dropdown.nextElementSibling;
				contentElement.addEventListener('transitionend', () => {
					ScrollTrigger.refresh();
				});
			}
		})
	};

	dropdownInit();


	function showNavBarAttachments(isShow){
		document.querySelectorAll('[data-nav-bar-attachment]')?.forEach(element => {
			element.classList.toggle('show',isShow);
		});	
	}

	// SCROLL LOGIC
	function assignFooterHeight(){
		let footer_height = document.querySelector('footer').offsetHeight;
		document.body.style.setProperty('--footer-height', (footer_height+'px'));
	}

	function assignHeaderHeight(){
		let header_height = header.offsetHeight;
		document.body.style.setProperty('--header-height', (header_height+'px'));
	}	

	// initial headerHeight
	assignHeaderHeight();
	assignFooterHeight();
	window.addEventListener("resize", throttle(assignHeaderHeight, 100), { passive: true })
	window.addEventListener("resize", throttle(assignFooterHeight, 100), { passive: true })


	

	let lastScrollOffset = 0;
	// Scrolling logic with subnav
	function updateHeaderColor() {
		if (!document.querySelector('[data-use-transparent-header]')) return false;
		
		const scrollOffset = window.scrollY;
		const deltaY = scrollOffset - lastScrollOffset;

		if(scrollOffset > 20){
			header.classList.add("white-header");
		} else if (!header.classList.contains("active")) {
			header.classList.remove("white-header");
			
		}
	
		lastScrollOffset = scrollOffset; 
	}

	if (document.querySelector('[data-use-transparent-header]')) {
		const throttledScrollToShowHideHeader = throttle(updateHeaderColor, 150)
		
		window.addEventListener('scroll', (e)=>throttledScrollToShowHideHeader(e), { passive: true });
		/* Wheel event listener added because overscroll will not trigger a scroll event, and for some reason 
		   If you scroll too fast, the function doesn't run when it's scrollY=0. It gets a scrollY > 320 sometimes and keeps the header hidden
		*/
		window.addEventListener('wheel', (e)=>throttledScrollToShowHideHeader(e), { passive: true }); 
		// Mobile hide/show header on scroll disabled, if we need it for mobile, probably need to add a touchmove event listener
		throttledScrollToShowHideHeader();
	} else {
		header.classList.add("white-header");
	}

	// Scroll logic

	// initalise global vue app so multiple sections can be add to the site to use product cards 

	window.apps = {}

	let autoStageCounter = 1

	const appInitialise = () => {

		document.removeEventListener("vue-initialise", appInitialise) 

		// create a new app for any unmounted data-vue-app elements

		document.querySelectorAll('[data-vue-app]:not([data-v-app])').forEach(element => {

			if(!element.id) {
				element.id = 'vue-autostage-' + autoStageCounter++
			}
			
			window.apps[element.id] = buildApp(element.id)
			console.log('%cCreated app: ' + element.id)
		})

		splideInit();
		dropdownInit();

	}

	document.addEventListener('vue-initialise', appInitialise )
	document.dispatchEvent(new Event('vue-initialise'))

	const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(productRecommendationsSection);

        const url = productRecommendationsSection.dataset.url;

        fetch(url)
        .then(response => response.text())
        .then(text => {
			// console.log('text', text)
			
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
                productRecommendationsSection.innerHTML = recommendations.innerHTML;

				setTimeout(function(){
					document.addEventListener('vue-initialise', appInitialise )
					document.dispatchEvent(new Event('vue-initialise'))
				}, 100)
            }

        })
        .catch(e => {
            console.error(e);
        });
    };

    const productRecommendationsSection = document.querySelector('.product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px', threshold: .5});

    if (productRecommendationsSection) {
        observer.observe(productRecommendationsSection);
    }

	splideInit()

	// SPLIDE PRODUCT PAGE
	if(document.querySelector("[data-product-thumb-splide]")){
		const productThumbsplide = new Splide("[data-product-thumb-splide]", {
			direction: 'ttb',          
			autoHeight: true,
			heightRatio: 1,
			height:'460px',
			width: '100px',
			perPage: 4,
			gap: '16px',                  
			pagination: false,
			arrows: true,
			isNavigation: true,  
			breakpoints : {
			  768: {
				destroy: true
			  },
			},
			classes: {
				arrows: 'splide__arrows splide__arrows--auto-hide',
			},
		});
	
		const productMainsplide = new Splide("[data-product-main-splide]", {
			type	  : "loop",
			pagination: false,
			arrows    : false,
		});
	
		productMainsplide.sync( productThumbsplide );
		productMainsplide.mount();
		productThumbsplide.mount();
	}

	// // Story Carousels
	// if (document.querySelector("[data-splide-story-image]")){
	// 	const productStoryImageCount = document.querySelector("[data-splide-story-image]").dataset.count;
	

	// 	const productStoryImage = new splide("[data-splide-story-image]", {
	// 		loop: true,
	// 		loopedSlides: 10,
	// 		spaceBetween: 20,
	// 		centeredSlides: true, 
	// 		speed: 500, 
	// 		slidesPerView: 1.5,
	// 		threshold: 40,
	// 		breakpoints: {
	// 			1024: { 
	// 				spaceBetween: 40,
	// 				slidesPerView: productStoryImageCount,
	// 			}
	// 		}, 
	// 		autoplay: false, 
	// 		watchSlidesVisibility: true,
	// 		watchSlidesProgress: true,	
	// 		slideToClickedSlide: true
	// 	});

	// 	const productStoryText = new splide("[data-splide-story-text]", {
	// 		loop: true,
	// 		loopedSlides: 10,
	// 		spaceBetween: 16, 
	// 		centeredSlides: true,
	// 		speed: 500,
	// 		slidesPerView: 1,
	// 		autoplay: false,
	// 		allowTouchMove: false,
	// 		breakpoints: {
	// 			1024: {
	// 				spaceBetween: 40,
	// 			}
	// 		},
	// 		effect: 'fade',
	// 		fadeEffect: { 
	// 			crossFade: true 
	// 		}
	// 		// thumbs: {
	// 		// 	splide: productStoryImage,
	// 		// 	multipleActiveThumbs: false
	// 		// }
	// 	});
		
	// 	productStoryText.controller.control = productStoryImage;
	// 	productStoryImage.controller.control = productStoryText;

	// }

	// if (document.querySelector("[data-splide-profile-image]")){

	// 	const productProfileImage = new splide("[data-splide-profile-image]", {
	// 		loop: true,
	// 		loopedSlides: 10,
	// 		spaceBetween: 10,
	// 		centeredSlides: false, 
	// 		speed: 500, 
	// 		slidesPerView: 'auto',
	// 		threshold: 40,
	// 		// breakpoints: {
	// 		// 	1024: { 
	// 		// 		slidesPerView: 2.75
	// 		// 	}
	// 		// },
	// 		autoplay: false, 
	// 		watchSlidesVisibility: true,
	// 		watchSlidesProgress: true,	
	// 		slideToClickedSlide: true
	// 	});

	// 	const productProfileText = new splide("[data-splide-profile-text]", {
	// 		loop: true,
	// 		loopedSlides: 10,
	// 		spaceBetween: 10, 
	// 		centeredSlides: false,
	// 		speed: 500,
	// 		slidesPerView: 1,
	// 		autoplay: false,
	// 		allowTouchMove: false,
	// 		effect: 'fade',
	// 		fadeEffect: { 
	// 			crossFade: true 
	// 		}
	// 	});
		
	// 	productProfileText.controller.control = productProfileImage;
	// 	productProfileImage.controller.control = productProfileText;
	// }

	// if (document.querySelector("[data-splide-hashtag]")){

	// 	const hashtag = new splide("[data-splide-hashtag]", {
	// 		loop: false,
	// 		spaceBetween: 0,
	// 		centeredSlides: false, 
	// 		speed: 500,
	// 		// autoHeight: true,
	// 		slidesPerView: 'auto',
	// 		threshold: 40,
	// 		autoplay: {
	// 			delay: 3000,
	// 		}
	// 	});
	// }


	//  Header Search form
	
	const searchTrigger = document.querySelectorAll('[data-search-trigger]')
	const searchForm = document.querySelector('[data-search-form]')
	const searchFormWrapper = document.querySelector('[data-search-form-wrapper]')

	Array.from(searchTrigger).forEach((button)=>button.addEventListener('click', (e) => {
		e.preventDefault();
		// toggleAnimation(searchForm);
		toggleAnimation(searchFormWrapper);
		console.log(button)
		toggleAnimation(button);	
		document.dispatchEvent(new Event('searchTrigger'));
	}))
	
	

	//  Header Search form end

	// locale and currency form

	const localeSelector = document.querySelectorAll('[data-locale-selector]')
	const currencySelector = document.querySelectorAll('[data-currency-selector]')

	const localizationForm = document.querySelectorAll('[data-localization-form]')

	const localeIsoValue = document.querySelectorAll('[data-locale-iso-value]')
	const currencyIsoValue = document.querySelectorAll('[data-currency-iso-value]')

	Array.from(localeSelector).forEach((form)=>form.addEventListener('change', function() {
        localizationForm[0].submit()
    }));

	Array.from(currencySelector).forEach((form)=>form.addEventListener('change', function() {
        localizationForm[0].submit()
    }));

	Array.from(localeIsoValue).forEach((code)=>code.addEventListener('click', (e) => {
		e.preventDefault();
		localeSelector[0].value = code.dataset.localeIsoValue;
		triggerChange(localeSelector[0]);
	}));

	Array.from(currencyIsoValue).forEach((code)=>code.addEventListener('click', (e) => {
		e.preventDefault();
		currencySelector[0].value = code.dataset.currencyIsoValue;
		triggerChange(currencySelector[0]);
	}));

	function triggerChange(element) {
		let changeEvent = new Event('change');
		element.dispatchEvent(changeEvent);
	}

	// locale and currency form END

	

	
	// media query logic


	// window.addEventListener("resize", function() {
	// 	if (window.matchMedia(`(min-width: ${md})`).matches) {
	// 		console.log("Screen width is at least 768")
	// 	}
	// })
	
	
	// media query logic end

	const productDetails = document.querySelectorAll('[data-product-details]');
	// const productQuickButtons = document.querySelectorAll('[data-qb-button]');
	const productQuickModal = document.querySelectorAll('[data-qb-modal]');
	
	// creates a scope for the quick buy modal
	Array.from(productDetails).forEach((scope) => {
		var x = scope.dataset.productId

		const trigger = scope.querySelectorAll('[data-qb-button]')
		
		Array.from(trigger).forEach((item)=>item.addEventListener('click', (e) => {			
			e.preventDefault();
			toggleAnimation(document.querySelector('[data-qb-modal="'+x+'"]'));
			toggleAnimation(document.querySelector('[data-overlay="'+x+'"]'));
		}));

		const subscriptionToggle = scope.querySelectorAll('[data-sub-toggle]');
		
        Array.from(subscriptionToggle).forEach((item)=>item.addEventListener('click', (e) => {
            e.preventDefault();
            if (!item.classList.contains('active')) {
                Array.from(subscriptionToggle).forEach((button) => {
                    toggleAnimation(button);
                });
                toggleAnimation(document.querySelector('[data-frequency-selector="'+x+'"]'))
            }
        }));
		
	});

	// appends the modal to the body after setting up the scope.
	// This is required because the cards can sit within a transformed element and then can't be fixed to the screen
	Array.from(productQuickModal).forEach((modal) => {
		body.appendChild(modal);
	});

	if(window.accessToken) {

		var feed = new Instafeed({
			accessToken: window.accessToken,
			limit: window.limit,
			template: window.instagramTemplate,
			after: () => {
				document.querySelectorAll("#instafeed [data-placeholder]").forEach(item => item.remove() )
			}
		});
		// feed.run() when scroll to #instafeed
		var observerInsta = new IntersectionObserver(function(entries) {
			if (entries[0].isIntersecting === true) {
		feed.run();
				observerInsta.unobserve(document.querySelector('#instafeed'));
			}
		}, { threshold: [0] });
		observerInsta.observe(document.querySelector('#instafeed'));



	}
	
	
	// Share Api

	const shareButton = document.querySelector('.share-button');
	const shareDialog = document.querySelector('.share-dialog');
	const closeButton = document.querySelector('.close-button');

	if(shareButton) {

		shareButton.addEventListener('click', event => {
			if (navigator.share) {
				navigator.share({
					title: shareButton.dataset.title,
					url: shareButton.dataset.urlShare
				}).then(() => {
					console.log('Thanks for sharing!');
				})
					.catch(console.error);
			} else {
				toggleAnimation(shareDialog);
			}
		});

		closeButton.addEventListener('click', event => {
			toggleAnimation(shareDialog);
		});

	}

	// Copy URL

	const copyContent = document.querySelectorAll('[data-copy]');
	
	Array.from(copyContent).forEach((copy)=>copy.addEventListener('click', (e) => {
		e.preventDefault();
		// Get the text field
		var copyText = copy.querySelector("input");

		// Select the text field
		copyText.select();
		copyText.setSelectionRange(0, 99999); // For mobile devices
	  
		 // Copy the text inside the text field
		navigator.clipboard.writeText(copyText.value)
		.then(() => {
		  	console.log("successfully copied");
		})
		.catch(() => {
			console.log("something went wrong");
		});
	  
	}));

	const showPassword = document.querySelectorAll('[data-show-password]');
	
	Array.from(showPassword).forEach((password)=>password.addEventListener("change", (e) => {
		
		var scope = password.parentElement.parentElement

		var x = scope.querySelector('.password');
		
		if (x.type === 'password') {
			x.type = 'text';
		} else {
			x.type = 'password';
		}

		toggleContent(password.nextElementSibling);
	}));


	// toggle section

	// this is used in the account area to toggle between the pages/tags as well as to toggle between edit and add new address

	const toggleVisibility = document.querySelectorAll('[data-toggle-visibility]');
	const toggleWrapper = document.querySelectorAll('[data-toggle-wrapper]');

	Array.from(toggleVisibility).forEach((item)=>item.addEventListener('click', (e) => {
		// e.preventDefault();

		var selector = item.dataset.toggleVisibility

		Array.from(toggleVisibility).forEach((item)=> {
			if(item.hasAttribute('data-add-class')) {
				let addClass = item.dataset.addClass.split(' ');
				if (item.classList.contains(addClass[0])) {
					toggleAnimation(item);
				}
			}
		});
	
		Array.from(toggleWrapper).forEach((wrapper)=> {
			if(wrapper.hasAttribute('data-add-class')) {
				let addClass = wrapper.dataset.addClass.split(' ');
				if (wrapper.classList.contains(addClass[0])) {
					toggleAnimation(wrapper);
				}
			}
		});

		toggleAnimation(document.querySelector(`[data-toggle-wrapper="${selector}"]`));
		toggleAnimation(document.querySelector(`[data-toggle-visibility="${selector}"]`));
		equalheight();
		
	}));

	
	function triggerHashChange() {
		const hash = location.hash[0] == "#" ? location.hash.substring(1) : location.hash;
		if (hash) { 
			const hashSelector = document.querySelectorAll(`[data-toggle-visibility="${hash}"]`);
			hashSelector[0].click()
		}
	}

	triggerHashChange();

    window.addEventListener('hashchange', function(e) {
		triggerHashChange();
    }, false);
	

	document.addEventListener("click", function(event){ 

        if (!event.target.matches('[data-product-view]')) return;

		event && event.preventDefault();
		
		if(event.target.dataset.productView == 'false') {

			const ProductCards = document.querySelectorAll('[data-product-card]');

			Array.from(ProductCards).forEach((card)=> {
				toggleAnimation(card);
			})

			const ProductListToggle = document.querySelectorAll('[data-product-view]');
			Array.from(ProductListToggle).forEach((item)=> {
				item.dataset.productView = 'false';
				toggleAnimation(item);
			});
			event.target.dataset.productView = 'true';
		}

	});
	

	// const searchParamsPrev = window.location.search.slice(1);
	// const filterForm = document.querySelector('[data-filter-form]'); // the whole wrapper
	// const formInputs = filterForm.querySelectorAll('input') // all the inputs
	// const collectionSection = document.querySelector('[data-collection]'); // the sections to be async loaded
	// const sectionId = filterForm.dataset.filterForm // section Id

	// Array.from(formInputs).forEach((input)=>input.addEventListener("change", (e) => {
	// 	console.log('clicked', sectionId);
		
	// 	let formData = new FormData(filterForm);
	// 	let searchParams = new URLSearchParams(formData).toString();
	// 	history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);

	// 	// fetch new section
	// 	fetch(`${window.location.pathname}?section_id=${sectionId}&${searchParams}`)
	// 	.then(response => response.text())
	// 	.then((responseText) => {
	// 		unmountCollectionListingApp()
	// 		document.querySelector('#collection').innerHTML = new DOMParser().parseFromString(responseText, 'text/html').querySelector('#collection').innerHTML;
	// 		mountCollectionListingApp()
	// 	})
	// }));

	const flipCard = document.querySelectorAll('[data-flip-card]');

	Array.from(flipCard).forEach((card)=> {
		card.querySelectorAll('[data-flip-card-button]').forEach((button)=> button.addEventListener('click', (e) => {
		toggleAnimation(card);
		}))
	});


	const toggleParentButton = document.querySelectorAll('[data-toggle-parent]')

	Array.from(toggleParentButton).forEach((button)=> button.addEventListener('click', (e) => {
		
		var activeClass = button.parentElement.dataset.addClass.split(' ');
		var removeClass = button.parentElement.dataset.removeClass.split(' ');

		const siblings = getAllSiblings(button.parentElement, button.parentElement.parentElement);

		if (button.parentElement.classList.contains(removeClass[0])) {
			console.log('disable')
			// if the clicked button doesn't have active state
			Array.from(siblings).forEach(child => {
				if (child.classList.contains(activeClass[0])) {
					toggleAnimation(child)	
					toggleAnimation(child.querySelector('[data-toggle-sibling]'))
					toggleAnimation(child.querySelector('[data-toggle-sibling]').lastElementChild)
				}
			})
			toggleAnimation(button.parentElement)
			toggleAnimation(button.parentElement.querySelector('[data-toggle-sibling]'))
			toggleAnimation(button.parentElement.querySelector('[data-toggle-sibling]').lastElementChild)
			setTimeout(function(){
				button.parentElement.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
			}, 300)
		} else {
			console.log('able')
			// if the clicked button does have active state
			Array.from(siblings).forEach(child => {
				if (button.parentElement.classList.contains(activeClass[0])) {
					if (window.innerWidth > md) {
						toggleAnimation(child)
						toggleAnimation(child.querySelector('[data-toggle-sibling]'))
					} else {
						if (child.classList.contains(activeClass[0])) {
							toggleAnimation(child)
						} else {
							toggleAnimation(button.parentElement)
						}
					} 
				}
			})
			if (window.innerWidth < md) {
				toggleAnimation(button.parentElement.querySelector('[data-toggle-sibling]'))
			}
			toggleAnimation(button.parentElement.querySelector('[data-toggle-sibling]').lastElementChild)
			setTimeout(function(){
				button.parentElement.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
			}, 300)
		}
		
	}));

	document.querySelectorAll('[data-max-content-cap-ref]').forEach(item => {
		window.uncapSectionHeight(item);
	})
